import { ButtonHTMLAttributes } from "react";
import "./Button.scss";

const Color: React.FC<ButtonHTMLAttributes<any>> = (props: any) => {
  const { children, ...rest } = props;
  return (
    <button {...rest} className="button color">
      {children}
    </button>
  );
};

export default Color;
